import React from 'react';
import { Link, useParams } from 'react-router-dom';
import posts from '../Posts';

import './Blog.css';

function formatDate(dateStr) {
    const date = new Date(dateStr);

    return date.toLocaleDateString('ro-RO', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
}

const BlogPost = () => {
    const { id } = useParams();
    const post = posts.find((p) => p.id === id);

    if (!post) {
        return (
            <section className="blog-section">
                <div className="container blog-post-notfound">
                    <h2>Articolul nu a fost găsit</h2>
                    <p className="blog-subtitle">
                        Poate a fost mutat sau linkul e greșit.
                    </p>
                    <Link to="/blog" className="blog-card-btn">
                        ← Înapoi la Blog
                    </Link>
                </div>
            </section>
        );
    }

    const paragraphs = post.content
        .split('\n\n')
        .map((p) => p.trim())
        .filter(Boolean);

    return (
        <section className="blog-section">
            <article className="container blog-post">
                <Link to="/blog" className="blog-post-back">
                    ← Înapoi la Blog
                </Link>

                <div className="blog-card-meta">
                    <span className="blog-card-number">#{post.number}</span>
                    <span className="blog-card-date">{formatDate(post.date)}</span>
                    <span className="blog-card-dot" aria-hidden="true">
                        •
                    </span>
                    <span className="blog-card-read">{post.readTime}</span>
                </div>

                <h1 className="blog-post-title">{post.title}</h1>

                {post.tags?.length > 0 && (
                    <div className="blog-card-tags">
                        {post.tags.map((tag) => (
                        <span className="blog-card-tag" key={tag}>
                            #{tag}
                        </span>
                        ))}
                    </div>
                )}

                {post.cover && (
                    <div className="blog-post-cover">
                        <img src={post.cover} alt={post.title} />
                    </div>
                )}

                <div className="blog-post-content">
                    {paragraphs.map((block, index) => {
                        const isHtml = /^<([a-z][a-z0-9]*)\b[^>]*>/i.test(block);
                        if (isHtml) {
                            return <div key={index} dangerouslySetInnerHTML={{ __html: block }} />;
                        }
                        return <p key={index}>{block}</p>;
                    })}
                </div>
            </article>
        </section>
    );
};

export default BlogPost;